import React, { useId, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import ButtonBase from '@mui/material/ButtonBase';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';

import messages from './messages';

type FileInputProps = {
  label: React.ReactNode;

  onChange: (file: File) => void;
  value: string | { name: string };

  error: boolean;
  helperText: React.ReactNode;
};

const FileInput = (props: FileInputProps) => {
  const id = useId();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div>
      <InputLabel shrink htmlFor={id}>
        {props.label}
      </InputLabel>
      <input
        id={id}
        ref={inputRef}
        type="file"
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            props.onChange(file);
          }
        }}
      />
      <ButtonBase
        onClick={() => inputRef.current?.click()}
        sx={{ justifyContent: 'flex-start' }}
      >
        <Typography>
          {props.value && typeof props.value !== 'string' ? (
            <span key="file-name">{props.value.name}</span>
          ) : (
            <span key="select-file">
              <FormattedMessage {...messages.selectFile} />
            </span>
          )}
        </Typography>
      </ButtonBase>
      {props.error ? (
        <FormHelperText error>{props.helperText}</FormHelperText>
      ) : null}
    </div>
  );
};

export default FileInput;
